module.exports = __webpack_public_path__ + "img/file-checked.f664ce3c.svg";